import React from "react";
import { Button } from "@mui/material";

import { AiUsageThreadDetail } from "../types/MeGenTypes";

export type FetchAiUsage = (
  threadId: string,
  onSuccess: (detail: AiUsageThreadDetail) => void,
  onError: (message: string) => void
) => void;

type AiUsageButtonProps = {
  id: string;
  threadId: string | null;
  canViewAiUsage?: boolean;
  onFetchAiUsage?: FetchAiUsage;
  onOpen: () => void;
};

/** The shared entry point for run-level AI usage details. */
const AiUsageButton: React.FC<AiUsageButtonProps> = ({
  id,
  threadId,
  canViewAiUsage = false,
  onFetchAiUsage,
  onOpen,
}) => {
  if (!threadId || !canViewAiUsage || !onFetchAiUsage) return null;

  return (
    <Button
      id={id}
      size="small"
      variant="outlined"
      onClick={onOpen}
      sx={{
        textTransform: "none", fontSize: "0.75rem", borderRadius: "9999px",
        py: 0.25, px: 1.5, color: "#db2777", borderColor: "#f9a8d4", flexShrink: 0,
        "&:hover": { borderColor: "#db2777", backgroundColor: "#fdf2f8" },
      }}
    >
      AI Usage
    </Button>
  );
};

export default AiUsageButton;
